const palettes = {
  default: {
    // also known as "san2", "suikoden", "koukai", "lempe", "royal"
    id: 'default',
    name: '預設 (DOS)',
    codes: [
      '#000000', // Black
      '#55FF55', // Lime Green
      '#FF5555', // Red
      '#FFFF55', // Yellow
      '#5555FF', // Blue
      '#55FFFF', // Cyan
      '#FF55FF', // Magenta
      '#FFFFFF', // White
    ],
  },
  default_pc98: {
    // also known as "san1_pc98", "san2_pc98", "suikoden_pc98"
    id: 'default_pc98',
    name: '預設 (PC98)',
    codes: [
      '#000000', // Black
      '#00FF00', // Green
      '#FF0000', // Red
      '#FFFF00', // Yellow
      '#0000FF', // blue
      '#00FFFF', // Cyan
      '#FF00FF', // Magenta
      '#FFFFFF', // White
    ],
  },
  san3: {
    id: 'san3',
    name: '三國志III',
    codes: [
      '#000000', // Black
      '#10B251', // Kelly Green
      '#F35100', // Red-Orange
      '#F3E300', // Yellow
      '#0041F3', // Blue
      '#00C3F3', // Azure
      '#F351D3', // Pink
      '#F3F3F3', // White
    ],
  },
  san4: {
    id: 'san4',
    name: '三國志IV',
    codes: [
      '#302000',
      '#417120',
      '#B24120',
      '#D3B282',
      '#204182',
      '#418292',
      '#C38251',
      '#D3D3B2',
    ],
  },
  san5: {
    id: 'san5',
    name: '三國志V',
    codes: [
      '#202010',
      '#206510',
      '#BA3000',
      '#EFAA8A',
      '#104575',
      '#658A9A',
      '#BA7545',
      '#EFDFCF',
    ],
  },
  kohryuki: {
    id: 'kohryuki',
    name: '項劉記',
    codes: [
      '#000000', // Black
      '#418200', // Olive Green
      '#C34100', // Rust
      '#E3A251', // Apricot
      '#0030A2', // Royal Blue
      '#71A2B2', // Steel Blue
      '#B27171', // Rosy Brown
      '#F3E3D3', // Beige
    ],
  },
  royal_pc98: {
    id: 'royal_pc98',
    name: '魔法皇冠 (PC98)',
    codes: [
      '#000000',
      '#00BA65',
      '#FF5555',
      '#EFCF55',
      '#0065BA',
      '#459ADF',
      '#FF55FF',
      '#FFFFFF',
    ],
  },
};

export default palettes;
